import { Skeleton } from '@/components/ui/skeleton'

export function ProjectLoadingState() {
  return (
    <div className="space-y-4" role="status" aria-label="Loading projects" aria-live="polite" data-testid="projects-loading">
      <div className="flex items-center gap-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="h-4 flex-1" />
        ))}
      </div>
      {Array.from({ length: 6 }).map((_, row) => (
        <div key={row} className="flex items-center gap-4 py-3">
          {Array.from({ length: 8 }).map((_, col) => (
            <Skeleton key={col} className="h-4 flex-1" />
          ))}
        </div>
      ))}
    </div>
  )
}
